import {Component, OnInit, Output, EventEmitter, Input, ChangeDetectorRef, HostListener} from '@angular/core';
import {AgencyService, EmployeeService, FilterService, PermissionService} from 'app/_services';
import {FilterModel, LanguageModel, AvailabilityModel, EducationFilterModel, ProfessionalExperienceFilterModel} from 'app/_models/filter.model';
import {ProjectPlanningService, ProjectService} from 'app/_services';
import {ConfirmationService, MessageService} from 'primeng/api';
import {AppConfig} from '../../common/app.config';
import {Router} from '@angular/router';
import {DropdownOptions} from '../../../_models/dropdown-options';
import {TranslateService} from '@ngx-translate/core';
import { environment } from 'environments/environment';

@Component({
  moduleId: module.id,
  selector: 'app-employee-filter',
  templateUrl: `./filter.component.html`,
  styleUrls: ['./filter-style.scss'],
  providers: [MessageService, FilterService, ProjectPlanningService, EmployeeService, ConfirmationService]
})
export class FilterComponent implements OnInit {

  public dropDownOptions = DropdownOptions;
  branches = [];
  bodyHeight = [];
  filter: FilterModel = new FilterModel();
  clientId = null;
  templates = [];
  filteredTemplates = [];
  template = null;
  getUserPictureThumbnailPath = AppConfig.getUserPictureThumbnailPath;

  role_id = null;
  showShiftAndDate = false;
  isSubmitted = false;
  contentEditable = [];
  isSubmittedAsTemplate = false;
  filteredEmployeesVb = false;
  saveAsTemplateInput = false;
  sendEmailModalVb = false;
  saveAsListInput = false;
  saveAsBlacklistInput = false;
  searchEmployeeByName = '';
  employeesFilteredAmount = 0;
  employeesFiltered = [];
  seenFilteredEmployees = [];
  // This component is a single instance shared by every role, and the employee queries are slow
  // enough to come back out of order. Responses carry the sequence they were issued with so a
  // late one belonging to a previously opened role can be discarded instead of overwriting the
  // list that is currently on screen.
  private employeeRequestSeq = 0;
  countTotalEmployeesMatched = 0;
  employeeCount = null;
  includingPublicEmployeesCount = null;
  employeesDeselected = 0;
  initialGroups = [];
  groups = [];
  initialAdditionalGroups = [];
  additionalGroups = [];
  blacklistGroups = [];
  emailSubject = null;
  emailBody = null;
  loading = false;
  publicDiff = 0;
  filterFromEmployeeDashboard = false;
  showFilterAvailabilityChbx = false;
  unavailablePeriods = [];

  isFilterTemplateLoading = false;

  showModal = false;
  public showTemplateModal = false;
  public removeFBA = false;

  public currentLanguage = localStorage.getItem('Language');

  public agencyName = environment.agencyName;

  public loadingGroups = false;
  public showStatusOverrideWarning = false;
  public currentUser = JSON.parse(localStorage.getItem('currentUser'));
  public canManageEmployeeLists = false;

  public consultants = [];
  public is_easytemp_agency = false;
  public additionalDocumentTypes = [];

  en: any;


  @Output() saved = new EventEmitter<any>();
  @Output() closed = new EventEmitter<any>();
  @Input() saveAsList = false;
  @Input() changeFilteringAddress = false;
  @Input() publicPool = false;
  @Input() isArchived = 0;
  @Input() canEditThisProject = true;

  public autocompleteOptions = {};
  filterClone: FilterModel;


  constructor(private filterService: FilterService,
              private agencyService: AgencyService,
              private router: Router,
              private messageService: MessageService,
              private projectPlanningService: ProjectPlanningService,
              private employeeService: EmployeeService,
              public translate: TranslateService,
              private cdr: ChangeDetectorRef,
              private permissionService: PermissionService,
              private confirmationService: ConfirmationService) {
    // this.clearFilter();
    for (let index = 100; index < 210; index++) {
      this.bodyHeight.push(index);
    }
  }

  ngOnInit() {

    if (localStorage.getItem("Language") === "de") {
      this.en = {
        firstDayOfWeek: 1,
        dayNames: [
          "Sonntag",
          "Montag",
          "Dienstag",
          "Mittwoch",
          "Donnerstag",
          "Freitag",
          "Samstag",
        ],
        dayNamesShort: ["Sun", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
        dayNamesMin: ["Su", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        monthNames: [
          "Januar",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember",
        ],
        monthNamesShort: [
          "Jan",
          "Feb",
          "Mär",
          "Apr",
          "Mai",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Okt",
          "Nov",
          "Dez",
        ],
        today: "Heute",
        clear: "Löschen",
        dateFormat: "mm/dd/yy",
        weekHeader: "Wk",
      };
    } else if (localStorage.getItem("Language") === "fr") {
      this.en = {
        firstDayOfWeek: 1,
        dayNames: [
          "Dimanche",
          "Lundi",
          "Mardi",
          "Mercredi",
          "Jeudi",
          "Vendredi",
          "Samedi",
        ],
        dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
        dayNamesMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
        monthNames: [
          "Janvier",
          "Février",
          "Mars",
          "Avril",
          "Mai",
          "Juin",
          "Juillet",
          "Août",
          "Septembre",
          "Octobre",
          "Novembre",
          "Décembre",
        ],
        monthNamesShort: [
          "Jan",
          "Fév",
          "Mar",
          "Avr",
          "Mai",
          "Jui",
          "Jui",
          "Aoû",
          "Sep",
          "Oct",
          "Nov",
          "Déc",
        ],
        today: "Aujourd'hui",
        clear: "Dégager",
        dateFormat: "mm/dd/yy",
        weekHeader: "Wk",
      };
    } else {
      this.en = {
        firstDayOfWeek: 1,
        dayNames: [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],
        dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        monthNames: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        monthNamesShort: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        today: "Today",
        clear: "Clear",
        dateFormat: "mm/dd/yy",
        weekHeader: "Wk",
      };
    }

    this.permissionService.canAccessFunctionality('Manage Employee Lists').subscribe(response => {
      this.canManageEmployeeLists = response;
    });

    this.agencyService.getAgencyBranches().subscribe(response => {
      var branchesResp: any = [];
      for(var i=0; i < response.branches.length; i++){
        var branch: any = {
          name: response.branches[i].name,
          value: response.branches[i].id + ""
        }
        branchesResp.push(branch);
      }
      this.branches = branchesResp;
    });

    this.employeeService.getAgencyGroups({branches: this.filter.branch_types}).subscribe(response => {
      this.initialGroups = response.groups.map(gr => {
        return {name: gr.name, id: gr.id};
      });

      this.groups = response.groups.map(gr => {
        return {name: gr.name, id: gr.id};
      });
    });

    this.employeeService.getAgencyAdditionalGroups({branches: this.filter.branch_types}).subscribe(response => {
      this.initialAdditionalGroups = response.groups.map(gr => ({name: gr.name, id: gr.id}));
      this.additionalGroups = response.groups.map(gr => ({name: gr.name, id: gr.id}));
    });

    this.employeeService.getAgencyBlacklistGroups().subscribe(response =>{
      this.blacklistGroups = response['blacklist-groups'].map(group => {
        return {name: group.name, id: group.id}
      })
    });

    this.agencyService.getAgencyName(this.currentUser.agency_id).subscribe(r1 => {
      let currentAgName = r1.agency_name;
      let isEasyTemp = r1.is_easytemp;
      this.is_easytemp_agency = isEasyTemp ? true : false;
      if (this.is_easytemp_agency) {
          this.employeeService.getConsultants({agency_name: currentAgName}).subscribe((res) => {
              this.consultants = res.consultants;
          });
      }
    });

    this.employeeService.getAdditionalDocumentTypes().subscribe(response => {
      this.additionalDocumentTypes = response.data || [];
    });

  }

  getDocFilter(typeId: number) {
    if (!this.filter.additional_documents_filter) {
      this.filter.additional_documents_filter = {};
    }
    if (!this.filter.additional_documents_filter[typeId]) {
      this.filter.additional_documents_filter[typeId] = { yes: false, no: false };
    }
    return this.filter.additional_documents_filter[typeId];
  }

  getDocumentTypeName(type: any): string {
    if (!type) return '';
    const lang = this.currentLanguage || 'en';
    let translations = type.field_translations;
    if (typeof translations === 'string') {
      try { translations = JSON.parse(translations); } catch (e) { translations = null; }
    }
    if (translations) {
      return translations[lang] || translations['en'] || translations['de'] || type.name || '';
    }
    return type.name || '';
  }

  getMultipleAgencyGroups() {
    // if(
    //   this.filter?.branch_types?.length > 1 || 
    //   (this.filter?.branch_types?.length == 1 && (this.filter?.branch_types[0] != this.currentUser.agency_id))){
    //   this.loadingGroups = true;

    //   this.employeeService.getMultipleAgencyGroups(this.filter?.branch_types).subscribe(response => {
    //     this.groups = response.groups.map(gr => {
    //       return {name: gr.name, id: gr.id};
    //     });

    //     this.loadingGroups = false;
    //   })
    // }
  }

  resetMultipleAgencyGroups() {
    if(!this.filter.other_branches) {
      this.groups = this.initialGroups.map(gr => {
        return {name: gr.name, id: gr.id};
      });
      this.additionalGroups = this.initialAdditionalGroups.map(gr => ({name: gr.name, id: gr.id}));
    }
  }

  show() {
    this.clientId = this.filter.client_id;
    this.employeeCount = null;
    this.countTotalEmployeesMatched = null;

    // Drop the previous role's employees before showing this one. They used to survive here, so
    // any click ran countDeselected() over the previous role's list and wrote those ids into this
    // role's filter.
    this.employeesFiltered = [];
    this.seenFilteredEmployees = [];
    this.employeesDeselected = 0;
    this.searchEmployeeByName = '';

    this.filterClone = JSON.parse(JSON.stringify(this.filter));

    this.filterChanged(true);
    this.showModal = true;
    this.getEmployeeLists();
    this.getAdditionalEmployeeLists();
    this.getBlackLists();
  }

  getAdditionalEmployeeLists() {
    this.employeeService.getAgencyAdditionalGroups({branches: this.filter.branch_types}).subscribe(response => {
      const groupsArray = Array.isArray(response?.groups) ? response.groups : [];
      this.additionalGroups = groupsArray.map(gr => ({name: gr.name, id: gr.id}));

      const missingGroupIds = [];
      if (!Array.isArray(this.filter.additional_employee_lists)) {
        this.filter.additional_employee_lists = [];
      }
      this.filter.additional_employee_lists = this.filter.additional_employee_lists.filter(id => {
        const found = this.additionalGroups.some(group => group.id === id);
        if (!found) missingGroupIds.push(id);
        return found;
      });

      if (missingGroupIds.length > 0) {
        this.filterChanged();
      }
    });
  }

  getEmployeeLists() {
    // if(this.filter?.branch_types?.length > 0) {
      this.employeeService.getAgencyGroups({branches: this.filter.branch_types}).subscribe(response => {
  
          const groupsArray = Array.isArray(response?.groups) ? response.groups : [];
  
          this.groups = groupsArray.map(gr => {
              return {name: gr.name, id: gr.id};
          });
  
          const missingGroupIds = [];
          this.filter.employee_lists = this.filter.employee_lists.filter(id => {
              const found = this.groups.some(group => group.id === id);
              if (!found) {
                  missingGroupIds.push(id);
              }
              return found;
          });
  
          if(missingGroupIds.length > 0) {
              this.filterChanged();
          }
      });
    // } else {
    //   this.groups = [];
    //   this.filter.employee_lists = [];
    // }
  }

  getBlackLists() {
    this.employeeService.getAgencyBlacklistGroups().subscribe(response =>{
      this.blacklistGroups = response['blacklist-groups'].map(group => {
        return {name: group.name, id: group.id}
      })
    })
  }

  private formatLocalDate(date: any): string {
    if (!date || !(date instanceof Date)) return date;
    const y = date.getFullYear();
    const m = ('0' + (date.getMonth() + 1)).slice(-2);
    const d = ('0' + date.getDate()).slice(-2);
    return `${y}-${m}-${d}`;
  }

  private buildFilterPayload() {
    return {
      ...this.filter,
      future_jobs_from: this.formatLocalDate(this.filter.future_jobs_from),
      future_jobs_to: this.formatLocalDate(this.filter.future_jobs_to),
      job_history_from: this.formatLocalDate(this.filter.job_history_from),
      job_history_to: this.formatLocalDate(this.filter.job_history_to),
      imported_job_history_from: this.formatLocalDate(this.filter.imported_job_history_from),
      imported_job_history_to: this.formatLocalDate(this.filter.imported_job_history_to),
      main_address_valid_from_from: this.formatLocalDate(this.filter.main_address_valid_from_from),
      main_address_valid_from_to: this.formatLocalDate(this.filter.main_address_valid_from_to),
      second_address_valid_from_from: this.formatLocalDate(this.filter.second_address_valid_from_from),
      second_address_valid_from_to: this.formatLocalDate(this.filter.second_address_valid_from_to),
      registration_date_from: this.formatLocalDate(this.filter.registration_date_from),
      registration_date_to: this.formatLocalDate(this.filter.registration_date_to),
      date_of_application_from: this.formatLocalDate(this.filter.date_of_application_from),
      date_of_application_to: this.formatLocalDate(this.filter.date_of_application_to),
      interview_date_from: this.formatLocalDate(this.filter.interview_date_from),
      interview_date_to: this.formatLocalDate(this.filter.interview_date_to),
      activation_date_from: this.formatLocalDate(this.filter.activation_date_from),
      activation_date_to: this.formatLocalDate(this.filter.activation_date_to),
      first_day_of_work_from: this.formatLocalDate(this.filter.first_day_of_work_from),
      first_day_of_work_to: this.formatLocalDate(this.filter.first_day_of_work_to),
      inactivation_date_from: this.formatLocalDate(this.filter.inactivation_date_from),
      inactivation_date_to: this.formatLocalDate(this.filter.inactivation_date_to),
      last_mobile_login_from: this.formatLocalDate(this.filter.last_mobile_login_from),
      last_mobile_login_to: this.formatLocalDate(this.filter.last_mobile_login_to),
      work_permit_expiry_from: this.formatLocalDate(this.filter.work_permit_expiry_from),
      work_permit_expiry_to: this.formatLocalDate(this.filter.work_permit_expiry_to),
      marital_status_valid_from_from: this.formatLocalDate(this.filter.marital_status_valid_from_from),
      marital_status_valid_from_to: this.formatLocalDate(this.filter.marital_status_valid_from_to),
    };
  }

  filterChanged(initialLoad = false) {
    this.loading = true;
    const seq = ++this.employeeRequestSeq;

    this.filterService.filteredEmployeesAmount(this.buildFilterPayload()).subscribe(response => {
      if (seq !== this.employeeRequestSeq) {
        return;
      }
      this.publicDiff = response.public_diff;
      if (!Array.isArray(response.employees)) {
        response.employees = Object.keys(response.employees).map((key) => [Number(key), response.employees[key]]);
      }
    
      let selectedEmployeeCount = 0;
      this.employeesFiltered = response.employees.map(emp => {
        let isEmployeeSelected = false;

        if(this.filter.is_deselect_clicked){
          if(this.filter.preselected_employee_ids.includes(emp.id)) {
            isEmployeeSelected = true;
            selectedEmployeeCount++;
          } else {
            isEmployeeSelected = false;
          }
        } else if(!this.filter.is_deselect_clicked){
          if(!this.filter.deselected_employee_ids.includes(emp.id)) {
            isEmployeeSelected = true;
            selectedEmployeeCount++;
          } else {
            isEmployeeSelected = false;
          }
        }

        return {...emp, selected: isEmployeeSelected};
      });

      this.seenFilteredEmployees = [...this.employeesFiltered];
      this.countTotalEmployeesMatched = this.seenFilteredEmployees.length;
      this.employeeCount = selectedEmployeeCount;
      this.searchEmployeeByName = '';
      this.sortEmployees();
      this.loading = false;
    });
  }

  sortEmployees() {
    this.seenFilteredEmployees.sort((a, b) => {
      if (a.selected === b.selected) {
        return a.last_name.localeCompare(b.last_name);
      } else if (a.selected) {
        return -1;
      } else {
        return 1;
      }
    });
  }

  otherBranchesChanged(){
    this.filter.other_branches = true;
  }

  respondSaved() {
    const seq = ++this.employeeRequestSeq;
    this.filterService.filteredEmployeesAmount(this.buildFilterPayload()).subscribe(response => {
      if (seq !== this.employeeRequestSeq) {
        return;
      }
      this.employeesFiltered = response.employees.map(emp => {
        return {...emp, selected: true};
      });
      this.seenFilteredEmployees = [...this.employeesFiltered];
      this.countTotalEmployeesMatched = this.seenFilteredEmployees.length;
      this.employeeCount = this.seenFilteredEmployees.length;
      this.saved.emit({filteredEmployees: this.employeesFiltered, filterAmount: this.employeesFiltered.length, filter: this.filter});
      this.isSubmitted = false;
      this.close(false);
    });
  }

  close(shouldClearFilter = true) {
    if(shouldClearFilter){
      this.clearFilter();
    }

    this.isSubmitted = false;
    this.isSubmittedAsTemplate = false;
    this.showStatusOverrideWarning = false;
    this.showModal = false;
    this.searchEmployeeByName = '';
    this.employeesFiltered = [];
    this.seenFilteredEmployees = [];
    this.employeeCount = 0;
    this.filteredEmployeesVb = false;
    this.closed.emit(true);

  }

  loadFilter(template) {
    this.filter = Object.assign(new FilterModel(), JSON.parse(template.body));

    if (!this.filterFromEmployeeDashboard) {
      const hasNonActiveStatus = this.filter.inactive_status || this.filter.incomplete_status || this.filter.applied_status || this.filter.edited_status || this.filter.expired_status;

      this.filter.active_status = true;
      this.filter.inactive_status = false;
      this.filter.incomplete_status = false;
      this.filter.applied_status = false;
      this.filter.edited_status = false;
      this.filter.expired_status = false;

      this.showStatusOverrideWarning = hasNonActiveStatus;
    } else {
      this.filter.public_pool = false;
    }

    this.getEmployeeLists();
    this.getAdditionalEmployeeLists();
    this.filterChanged();
  }

  deselectedEmployeesFill() {
    if (!this.filter.deselected_employee_ids) {
      this.filter.deselected_employee_ids = [];
    }
    for (let i = 0; i < this.employeesFiltered.length; i++) {
      if (!this.employeesFiltered[i].selected) {
        this.filter.deselected_employee_ids.push(this.employeesFiltered[i].id);
      }
    }
  }

  saveFilterAsTemplate() {
    if (!this.filter.name) {
        this.translate.get('To save a template filter, name is required!').subscribe(res => {
            this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: res});
        });
      return;
    }
    this.isSubmitted = true;
    // Templates preserve the whole filter body — criteria plus per-person state
    // (deselected_employee_ids, preselected_employee_ids, is_deselect_clicked). The load path
    // is intentionally symmetric so a saved selection reappears verbatim when the template is
    // applied to a new role or project.
    this.projectPlanningService.saveTemplate({
      name: this.filter.name, type: 'filter',
      body: JSON.stringify(this.filter)
    }).subscribe(response => {
      if (response.status === 'error') {
          this.translate.get(response.message).subscribe(res => {
              this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: res});
          });
          this.isSubmitted = false;
          this.isSubmittedAsTemplate = false;
      } else if (response.status === 'exists') {
        this.translate.get("Template with this name already exists. Do you want to overwrite it?").subscribe(res => {
          this.confirmationService.confirm({
            header: this.translate.instant('Confirmation'),
            message: res,
            accept: () => {
              this.overwriteFilterTemplate(this.filter);
            },
            reject: () => {
              this.isSubmitted = false;
              this.isSubmittedAsTemplate = false;
            }
          });
        });
      } else if (response.status === 'success') {
        this.templates = response.templates;
        this.respondSaved();
      }
    }, err => {
      this.isSubmitted = false;
      this.isSubmittedAsTemplate = false;
    });
    this.isSubmittedAsTemplate = true;
  }

  overwriteFilterTemplate(filter) {
    this.projectPlanningService.saveExistingTemplate({
      name: this.filter.name, type: 'filter',
      body: JSON.stringify(filter)
    }).subscribe(response => {
      if (response.status === 'error') {
        this.translate.get(response.message).subscribe(res => {
          this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: res});
        });
      } else if (response.status === 'success') {
        this.templates = response.templates;
        this.respondSaved();
      }
      this.isSubmitted = false;
      this.isSubmittedAsTemplate = false;
    }, err => {
      this.isSubmitted = false;
      this.isSubmittedAsTemplate = false;
    });
  }

  saveFilter() {
    // this.deselectedEmployeesFill();
    // this.saveEmployeeSelection();
    this.respondSaved();
  }

  saveEmployeeSelection() {
    console.log(this.seenFilteredEmployees);
    let preSelectedEmployeeIds = [];
    let deSelectedEmployeeIds = [];
    this.seenFilteredEmployees.forEach(emp => {
      if(emp.selected) {
        preSelectedEmployeeIds.push(emp.id);
      } else {
        deSelectedEmployeeIds.push(emp.id);
      }
    });

    this.filter.deselected_employee_ids = deSelectedEmployeeIds;
    this.filter.preselected_employee_ids = preSelectedEmployeeIds;
  }

  saveList() {
    if (this.filter.name && this.filter.name.length > 1) {
      this.isSubmitted = false;

      const filteredIds = this.employeesFiltered.reduce( (result, employee) => {
        if(this.filter.is_deselect_clicked){
          if (this.filter.preselected_employee_ids.includes(employee.id)) {
            return [...result, employee.id];
          }
        } else {
          if (!this.filter.deselected_employee_ids.includes(employee.id)) {
            return [...result, employee.id];
          }
        }
        return result;
      }, []);

      this.employeeService.addListToNewGroup({group: this.filter.name, employee_ids: filteredIds})
        .subscribe(response => {
          this.filter.name = '';
            this.translate.get('List saved!').subscribe(res => {
                this.messageService.add({severity: 'success', summary: this.translate.instant('Success!'), detail: res});
            });
        });
    } else {
        this.translate.get('Please provide a list name!').subscribe(res => {
            this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: res});
        });
    }
  }

  saveBlacklist() {
    if (this.filter.name && this.filter.name.length > 1) {
      this.isSubmitted = false;

      const filteredIds = this.employeesFiltered.reduce( (result, employee) => {
        if(this.filter.is_deselect_clicked){
          if (this.filter.preselected_employee_ids.includes(employee.id)) {
            return [...result, employee.id];
          }
        } else {
          if (!this.filter.deselected_employee_ids.includes(employee.id)) {
            return [...result, employee.id];
          }
        }
        return result;
      }, []);

      this.employeeService.addBlacklistToNewGroup({group: this.filter.name, employee_ids: filteredIds})
        .subscribe(response => {
          this.filter.name = '';
            this.translate.get('List saved!').subscribe(res => {
                this.messageService.add({severity: 'success', summary: this.translate.instant('Success!'), detail: res});
            });
        });
    } else {
        this.translate.get('Please provide a list name!').subscribe(res => {
            this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: res});
        });
    }
  }

  clearFilter() {
    this.showStatusOverrideWarning = false;
    this.filter = new FilterModel();
    this.filter.client_id = this.clientId;
    var currentUserAgencyId = JSON.parse(localStorage.getItem('currentUser'))?.agency_id + "";
    this.filter.branch_types = [currentUserAgencyId];
    this.filterChanged();
  }

  getAddress($event, addressNr) {
    if (addressNr === 1) {
      this.filter.main_address = $event.formatted_address;
      this.filter.latitude = $event.geometry.location.lat();
      this.filter.longitude = $event.geometry.location.lng();
    } else {
      this.filter.second_address = $event.formatted_address;
      this.filter.latitude = $event.geometry.location.lat();
      this.filter.longitude = $event.geometry.location.lng();
    }
  }

  showProfessionModal = '';
  selectedExperience: any = null;

  openProfessionModal(i: number) {
    this.showProfessionModal = 'profession-' + i;
  }

  activeProfessionMenu(exp: any) {
    this.selectedExperience = exp;
  }

  onProfessionItemSelected(event: any) {
    if (event.value && this.selectedExperience) {
      this.selectedExperience.profession = event.value;
      this.filterChanged();
      this.removeDeselection();
    }
    this.showProfessionModal = '';
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.showProfessionModal = '';
  }

  addExperienceFilter() {
    if (!this.filter.experiences || !this.filter.experiences.length) {
      this.filter.experiences = [];
    }
    this.filter.experiences.push(new ProfessionalExperienceFilterModel());
    this.filterChanged();
  }

  removeExperienceFilter(i) {
    this.filter.experiences.splice(i, 1);
    this.filterChanged();
  }

  addEducationFilter() {
    if (!this.filter.educations || !this.filter.educations.length) {
      this.filter.educations = [];
    }
    this.filter.educations.push(new EducationFilterModel());
    this.filterChanged();
  }

  removeEducationFilter(i) {
    this.filter.educations.splice(i, 1);
    this.filterChanged();
  }

  onDateInput(event: any, obj: any, field: string) {
    if (!event.target.value) {
      obj[field] = null;
      this.filterChanged();
      this.removeDeselection();
    }
  }

  addLanguage() {
    if (!this.filter.languages || !this.filter.languages.length) {
      this.filter.languages = [];
    }
    this.filter.languages.push(new LanguageModel());
    this.filterChanged();
  }

  removeLanguage(i) {
    this.filter.languages.splice(i, 1);
    this.filterChanged();
  }

  addAvailability() {
    if (!this.filter.weekly_availabilities || !this.filter.weekly_availabilities.length) {
      this.filter.weekly_availabilities = [];
    }
    this.filter.weekly_availabilities.push(new AvailabilityModel());
  }

  removeAvailability(i) {
    this.filter.weekly_availabilities.splice(i, 1);
    this.filterChanged();
  }

  trackByFn(i: number) {
    return i;
  }

  showFilterTemplates() {
    this.showTemplateModal = true;
  }

  searchByName() {
    if (this.searchEmployeeByName.length === 0) {
      this.seenFilteredEmployees = [...this.employeesFiltered];
      return;
    }
    this.seenFilteredEmployees = this.employeesFiltered.filter( x => {
      const first_name = x.first_name.toLowerCase();
      const last_name = x.last_name.toLowerCase();
      return (first_name.indexOf(this.searchEmployeeByName.toLowerCase()) > -1)
        || (last_name.indexOf(this.searchEmployeeByName.toLowerCase()) > -1);
    });
  }

  selectAllEmployees() {
    this.filter.is_deselect_clicked = false;
    this.filter.deselected_employee_ids = [];
    this.filter.preselected_employee_ids = [];
    this.employeesDeselected = 0;
    // Select the whole matched set, not just the rows the name search happens to be showing.
    // countDeselected() walks employeesFiltered, so anything left unselected here was treated as
    // an explicit deselection on the next click and never got invited.
    this.employeesFiltered.forEach(emp => {
      emp.selected = true;
    });

    this.employeeCount = this.employeesFiltered.length;
  }

  deselectAllEmployees() {
    this.filter.is_deselect_clicked = true;
    this.filter.preselected_employee_ids = [];
    this.employeesFiltered = this.employeesFiltered.map(emp => {
      return {...emp, selected: false, showConflictModal: false};
    });
    this.seenFilteredEmployees = [...this.employeesFiltered];
    this.countTotalEmployeesMatched = this.seenFilteredEmployees.length;
    this.employeeCount = 0;
    this.searchEmployeeByName = '';
    this.employeesDeselected = this.employeesFiltered.length;
  }

  countDeselected() {
    this.employeesDeselected = 0;
    this.employeeCount = 0;
    const deselectedEmps = [];
  
    for (let i = 0; i < this.employeesFiltered.length; i++) {
      const employeeId = this.employeesFiltered[i].id;
  
      if (this.filter.is_deselect_clicked) {
        if (this.employeesFiltered[i].selected) {
          this.employeeCount++;
          if (!this.filter.preselected_employee_ids.includes(employeeId)) {
            this.filter.preselected_employee_ids.push(employeeId);
          }
        } else {
          this.employeesDeselected++;
          const index = this.filter.preselected_employee_ids.indexOf(employeeId);
          if (index !== -1) {
            this.filter.preselected_employee_ids.splice(index, 1);
          }
        }
      } else {
        if (!this.employeesFiltered[i].selected) {
          this.employeesDeselected++;
          deselectedEmps.push(employeeId);
        } else {
          this.employeeCount++;
          const sid = this.filter.deselected_employee_ids.indexOf(employeeId);
          if (sid >= 0) {
            this.filter.deselected_employee_ids.splice(sid, 1);
          }
        }
      }
    }
  
    if (!this.filter.is_deselect_clicked) {
      this.filter.deselected_employee_ids = deselectedEmps.concat(this.filter.deselected_employee_ids.filter(function (item) {
        return deselectedEmps.indexOf(item) < 0;
      }));
    }

    this.sortEmployees();
  }

  sendEmailToSelectedEmployees() {
    this.filterService.sendEmailToSelectedEmployees({
        employees: this.employeesFiltered,
        subject: this.emailSubject,
        body: this.emailBody
    }).subscribe();
  }

  over() {
    this.showShiftAndDate = true;
  }

  out() {
    this.showShiftAndDate = false;
  }

  addUnavailablePeriod() {
    this.filter.availablePeriods.push({from: null, to: null});
    this.filterChanged();
  }

  removeUnavailablePeriod(index) {
    this.filter.availablePeriods.splice(index, 1);
    this.filterChanged();
  }

  removeDeselection() {
    // this.filter.is_deselect_clicked = false;
  }

  changeIsDeselectClicked(event) {
    console.log(event.checked);
    if(event.checked) {
      this.filter.is_deselect_clicked = true;
    } else {
      this.filter.is_deselect_clicked = false;
    }
    this.cdr.detectChanges();
  }

  resetFilter(){
    console.log('clone', this.filterClone);
    this.filter = this.filterClone;
  }

  openFilterTemplateModal(){
    this.isFilterTemplateLoading = true;
    this.projectPlanningService.loadTemplates('filter').subscribe(response => {
      this.templates = response.templates;
      this.filteredTemplates = [...this.templates];
      this.isFilterTemplateLoading = false;
    });
  }

  searchTemplates(value: string) {
    this.filteredTemplates = this.templates.filter(template =>
      template.name.toLowerCase().includes(value.toLowerCase())
    );
  }
}
